import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export const Breadcrumbs = ({ items }) => (
  <nav className="text-xs text-[#4A4947] flex items-center flex-wrap gap-1 mb-8" data-testid="breadcrumbs">
    {items.map((it, i) => (
      <span key={i} className="flex items-center gap-1">
        {i > 0 && <ChevronRight className="w-3 h-3" />}
        {it.to ? <Link to={it.to} className="hover:text-[#B35D4B]">{it.label}</Link> : <span className="text-[#1C1B1A]">{it.label}</span>}
      </span>
    ))}
  </nav>
);
